import { render, staticRenderFns } from "./CodeBrackets.vue?vue&type=template&id=2acaa175"
import script from "./CodeBrackets.vue?vue&type=script&lang=js"
export * from "./CodeBrackets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports